module.exports = __webpack_public_path__ + "img/profile-image.ddd8324f.jpg";